import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goHome = () => {
    navigate('/');
    setMenuOpen(false);
  };

  const goQuote = () => {
    if (isHome) {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#contact');
    }
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#1a1a1a] shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={goHome}>
          <div className="w-8 h-8 flex items-center justify-center bg-[#C9A84C] rounded-sm">
            <i className="ri-building-2-line text-white text-sm"></i>
          </div>
          <div>
            <span className="font-barlow font-800 text-white text-sm tracking-wide leading-none block">QUIROZ</span>
            <span className="font-inter text-[#C9A84C] text-[10px] tracking-widest leading-none block">CONSTRUCTION CLEANING</span>
          </div>
        </div>

        {/* Desktop Nav — Home & Gallery only */}
        <nav className="hidden md:flex items-center gap-8">
          <a
            href="/"
            className={`font-inter text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${isHome ? 'text-[#C9A84C]' : 'text-white/80 hover:text-[#C9A84C]'}`}
          >
            Home
          </a>
          <a
            href="/gallery"
            className={`font-inter text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${location.pathname === '/gallery' ? 'text-[#C9A84C]' : 'text-white/80 hover:text-[#C9A84C]'}`}
          >
            Gallery
          </a>
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+17022494799"
            className="flex items-center gap-2 text-white/70 hover:text-[#C9A84C] font-inter text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-[#C9A84C] text-sm"></i>
            </div>
            (702) 249-4799
          </a>
          <button
            onClick={goQuote}
            className="bg-[#C9A84C] hover:bg-[#E8C96A] text-[#1a1a1a] font-barlow font-700 text-sm px-5 py-2.5 rounded-sm transition-all duration-200 cursor-pointer whitespace-nowrap tracking-wide"
          >
            GET A QUOTE
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-white w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#1a1a1a] border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          <a href="/" className="text-white/80 font-inter text-sm text-left cursor-pointer whitespace-nowrap hover:text-[#C9A84C]">
            Home
          </a>
          <a href="/gallery" className="text-white/80 font-inter text-sm text-left cursor-pointer whitespace-nowrap hover:text-[#C9A84C]">
            Gallery
          </a>
          <a
            href="tel:+17022494799"
            className="flex items-center gap-2 text-white/70 font-inter text-sm cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line text-[#C9A84C] text-sm"></i>
            (702) 249-4799
          </a>
          <button
            onClick={goQuote}
            className="bg-[#C9A84C] text-[#1a1a1a] font-barlow font-700 text-sm px-5 py-3 rounded-sm cursor-pointer whitespace-nowrap tracking-wide"
          >
            GET A QUOTE
          </button>
        </div>
      )}
    </header>
  );
}
